import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_3 = { class: "u-mar-t-0" }
const _hoisted_4 = { class: "c-form-control-checkbox form-group" }
const _hoisted_5 = {
  class: "c-form-control-checkbox__label",
  for: "erklaerungUnterlagenErhalten"
}
const _hoisted_6 = { class: "c-form-control-checkbox__label-text" }
const _hoisted_7 = { class: "c-form-control-checkbox form-group" }
const _hoisted_8 = {
  class: "c-form-control-checkbox__label",
  for: "erklaerungZumProduktUndBeratungsverzicht"
}
const _hoisted_9 = { class: "c-form-control-checkbox__label-text" }
const _hoisted_10 = { class: "c-form-control-checkbox form-group" }
const _hoisted_11 = {
  class: "c-form-control-checkbox__label",
  for: "erklaerungWerbeeinwilligung"
}
const _hoisted_12 = { class: "o-grid o-grid--align-left" }
const _hoisted_13 = { class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024" }
const _hoisted_14 = {
  key: 0,
  class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_vorschlag_direkt = _resolveComponent("vorschlag-direkt")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.piniaStore.state.isMakler)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("strong", null, " Sie erhalten hiermit Ihre " + _toDisplayString(_ctx.getAntragOderVertrag) + "sunterlagen. Laden Sie bitte das nachfolgende PDF herunter, speichern dieses ab oder drucken es aus. ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" Ihre " + _toDisplayString(_ctx.getAntragOderVertrag) + "sunterlagen enthalten: Das Informationsblatt zu Versicherungsprodukten, das Tarifinformationsblatt, die Kundeninformationen (einschließlich Belehrung über das Widerrufsrecht), die Hinweise zur vorvertraglichen Anzeigepflicht, die Versicherungsbedingungen, die Satzung und die Datenschutzhinweise zur Antrags- und Vertragsverarbeitung. Diese sind Grundlage und Bestandteil Ihres Direktabschlusses. ", 1)
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("input", {
                type: "checkbox",
                class: "c-form-control-checkbox__input",
                id: "erklaerungUnterlagenErhalten",
                name: "erklaerungUnterlagenErhalten",
                required: "",
                "aria-required": "true",
                "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
                "data-cy": "erklaerungUnterlagenErhalten"
              }, null, -1)),
              _createElementVNode("label", _hoisted_5, [
                _createVNode(_component_icon_sprite, {
                  "ist-klein": true,
                  "css-klassen": "c-form-control-checkbox__icon",
                  "icon-name": "icon-check-mark"
                }),
                _createElementVNode("span", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createTextVNode("Ja, ich habe die ")),
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('vorschlag-herunterladen')), ["prevent"]))
                  }, _toDisplayString(_ctx.getAntragOderVertrag) + "sunterlagen ", 1),
                  _cache[8] || (_cache[8] = _createTextVNode(" zur Kenntnis genommen. Nach Abschluss erhalte ich die Unterlagen mit der Bestätigungs-E-Mail."))
                ])
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.erklaerungUnterlagenErhalten
              }, null, 8, ["fehler-text"])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("input", {
                type: "checkbox",
                class: "c-form-control-checkbox__input",
                id: "erklaerungZumProduktUndBeratungsverzicht",
                name: "erklaerungZumProduktUndBeratungsverzicht",
                required: "",
                "aria-required": "true",
                "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
                "data-cy": "erklaerungZumProduktUndBeratungsverzicht"
              }, null, -1)),
              _createElementVNode("label", _hoisted_8, [
                _createVNode(_component_icon_sprite, {
                  "ist-klein": true,
                  "css-klassen": "c-form-control-checkbox__icon",
                  "icon-name": "icon-check-mark"
                }),
                _createElementVNode("span", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "angaben-bestaetigen")
                ])
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.erklaerungZumProduktUndBeratungsverzicht
              }, null, 8, ["fehler-text"])
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "c-form-control-checkbox__input",
                id: "erklaerungWerbeeinwilligung",
                name: "erklaerungWerbeeinwilligung",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.werbeeinwilligung) = $event)),
                "data-cy": "erklaerungWerbeeinwilligung"
              }, null, 512), [
                [_vModelCheckbox, _ctx.piniaStore.state.werbeeinwilligung]
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_icon_sprite, {
                  "ist-klein": true,
                  "css-klassen": "c-form-control-checkbox__icon",
                  "icon-name": "icon-check-mark"
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, "Ich bin damit einverstanden, von der GEV per E-Mail oder per Telefon Informationen zu Produkten aus dem Bereich Versicherungen zu erhalten. Dieser Einwilligung kann ich jederzeit unter werbewiderspruch@grundvers.de widersprechen.", -1))
              ]),
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.erklaerungWerbeeinwilligung
              }, null, 8, ["fehler-text"])
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  id: "btnSummarySubmit",
                  class: "c-button c-button--full-width c-button--word-wrap-flex-height u-mar-b-6",
                  style: {"height":"3.5rem !important"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('antrag-absenden'))),
                  "data-cy": "btnSummarySubmit"
                }, _toDisplayString(_ctx.isDunkelverarbeitung ? "Jetzt sicher abschließen (beitragspflichtig)" : "Jetzt verbindlich beantragen"), 1)
              ]),
              (_ctx.sollAntragPerEmailSendenKoennen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      id: "btnSummarySubmit",
                      style: {"font-weight":"normal"},
                      class: "c-button c-button--inverted c-button--full-width c-button--word-wrap-flex-height u-mar-b-6",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.angabenSichern && _ctx.angabenSichern(...args))),
                      "data-cy": "btnSummarySubmit"
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("b", null, "Angaben sichern", -1),
                      _createTextVNode(),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Wiedereinstiegs-Link per E-Mail ")
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-vorschlagDirekt'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          text: 'Lassen Sie sich einen Vorschlag per E-Mail zusenden. Die E-Mail enthält neben dem Vorschlag auch einen Link, über den Sie jederzeit in den Tarifrechner zurückkehren können.',
          titel: 'Ihr Vorschlag per E-Mail',
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirekt')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_vorschlag_direkt, {
              antrag: false,
              "is-vorschlag-email": true,
              "ist-outbound-aktiv": _ctx.piniaStore.state.outbound.emailAktiv,
              produkt: _ctx.produkt,
              trackingZusatz: "abschluss",
              onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirekt'))),
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["ist-outbound-aktiv", "produkt", "onTextVerbergen"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}